import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export type ResizedImage = { width?: number; url?: string }
export type ImageLike = { url?: string; resizedImages?: Array<ResizedImage> }

export function getResizedImageUrl(
  image?: ImageLike,
  preferredWidth: number = 320
): string {
  const resized = image?.resizedImages?.find((img) => img.width === preferredWidth)?.url
  return resized || image?.url || ''
}